import React from 'react';
import { FormArrayRow, FormArrayRowProps } from 'src/components/Form';
import {
  useSolutionDeviceGroupPropOptions,
  useSolutionDeviceGroupProperties,
  useSolutionDevicePropertyMeta,
} from '../../redux';
import { getDeviceGroupFilterFields } from '../formFields';

function SolutionDeviceGroupEditFormRow({
  childFields,
  update,
  values,
  ...rest
}: FormArrayRowProps) {
  const [propertyOptions, propertiesLoading] =
    useSolutionDeviceGroupPropOptions();
  const { operators: operatorOptions, enums: filterValueOptions } =
    useSolutionDevicePropertyMeta(values?.property);
  const onPropertyChange = ({ target }) => {
    if (update) {
      // Reset both operatorValue and filterValue when property changes
      update(rest.index, {
        property: target.value,
        operatorValue: '', // Clear the operatorValue when property changes
        filterValue: '', // Clear the filterValue when property changes
      });
    }
  };
  const [properties] = useSolutionDeviceGroupProperties();
  const selectedProperty = properties.find((a) => a.id === values?.property);
  const filterOptions = [
    { value: 'true', label: 'True' },
    { value: 'false', label: 'False' },
  ];
  return (
    <FormArrayRow
      childFields={getDeviceGroupFilterFields({
        onPropertyChange,
        propertyOptions,
        selectedProperty,
        propertiesLoading,
        operatorOptions,
        filterValueOptions,
        filterOptions,
      })}
      {...rest}
    />
  );
}

export default SolutionDeviceGroupEditFormRow;
